import {
  Input,
  InputText,
  Textarea,
  Select,
  SelectAsync,
  Radio,
} from '../index';

const componentConfig = {
  input: Input,
  // 段落输入框
  'input-text': InputText,
  // 多行输入
  textarea: Textarea,
  // 选择器
  select: Select,
  radio: Radio,
  // 异步加载的select选择器
  'select-async': SelectAsync,
};

export default componentConfig;
